import React, { memo } from 'react'
import { makeStyles } from '@material-ui/styles';
import {Box} from '@material-ui/core';
import icnFooterArrowUp from './assets/images/icn-footer-arrow-up.gif'
import * as Constants from '../../../constants';

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: "#434343",
        color: '#c5c5c5',
        borderTop: '#616161 solid 1px',
        paddingBottom: '10em',
        '& a': {
            color: '#fff',
            textDecoration: 'none',
        },
        '& *': {
          fontFamily: "'Meiryo', 'Hiragino Sans', serif !important"
        }

    },
    pageTop: {
        paddingTop: 8,
        textAlign: 'center',
        width: 312,
    },
    link: {
        fontSize: 13
    },
    topPageLink: {
        display:'inline-block',
        padding: '10px 0 0 0',
        background: `url(${icnFooterArrowUp}) no-repeat top center`,
    },
    terms: {
        paddingTop: 10,
        fontSize: 11,
    },
    termContainer: {
        maxWidth: 976,
        margin: '0 auto',
        padding: '0 2px 0 2px',
        position: 'relative',
        '& ul': {
            listStyle: 'none',
        }
    },
    copyright: {
        margin: 0,
        textAlign: 'center',
        fontFamily: "OpenSansCond !important",
    },
    termLinks: {
        textAlign: 'center',
        fontSize: 0,
        '& li': {
            '&:first-child': {
                borderLeft: 'none',
            },
            borderLeft: '1px solid #c5c5c5',
            display: 'inline-block',
            padding: '0 5px',
            '& a': {
                fontSize: 11,
            }
        }
    }
}))

const Footer = memo(function Footer() {
    const classes = useStyles();

    const preventDefault = (e) => {
        e.preventDefault();
    }

    const goToTop = (e) => {
        preventDefault(e)
        window.scrollTo(0, 0)
    }

    return (
        <Box component="footer" width={1} className={classes.root} display="flex" flexDirection="column" alignItems="center">
                <Box className={classes.pageTop}>
                    <a className={`${classes.link} ${classes.topPageLink}`} href="#" onClick={goToTop}>ページの先頭へ</a>
                </Box>
                <Box className={classes.terms}>
                    <Box className={classes.termContainer}>
                        <p className={classes.copyright}>© {Constants.companyNameInEnglish_1}</p>
                        <ul className={classes.termLinks}>
                            <li>
                                <a href="https://www.panasonic.com/jp/sitemap.html" target="_blank">サイトマップ</a>
                            </li>
                            <li>
                                <a href="https://www.panasonic.com/jp/terms-of-use.html" target="_blank">サイトのご利用にあたって</a>
                            </li>
                            <li>
                                <a href="https://www.panasonic.com/jp/webaccessibility.html" target="_blank">ウェブアクセシビリティ方針</a>
                            </li>
                            <li>
                                <a href="https://panasonic.co.jp/ls/plsems/privacy/" target="_blank">個人情報保護方針</a>
                            </li>
                            <li>
                                <a href="https://www.panasonic.com/jp/home.html" target="_blank">パナソニック・ホーム</a>
                            </li>
                        </ul>
                    </Box>
                </Box>
            </Box>
    )
})

export default Footer
